import React, { PureComponent } from 'react'
import { CSSTransition } from 'react-transition-group'
import classNames from 'classnames'
import CSSModules from 'react-css-modules'

import { localize } from 'helpers/translator'
import TextLink from 'components/text_link/text_link'
import { TextInput } from 'components/dpc_input'
import ClickOutside from 'decorators/click_outside/click_outside_decorator'

import styles from './suggestion_list.scss'

class SuggestionList extends PureComponent {

	constructor() {
		super()
		this.state = {
			isOpened: false,
			locked: false,
			searchSuggestions: false,
		}
		this.searchSuggestions = this.searchSuggestions.bind(this)
		this.doFocus = this.doFocus.bind(this)
		this.doBlur = this.doBlur.bind(this)
		this.handleClickLastRow = this.handleClickLastRow.bind(this)
		this.handleClickOutside = this.handleClickOutside.bind(this)
	}

	searchSuggestions(evt) {
		this.props.searchAction(evt.target.value)
		this.props.fieldValue.input.onChange(evt)
		this.props.additionalOnChange(false)
		this.setState({ searchSuggestions: true })
	}

	handleClick(option) {
		this.props.fieldId.input.onChange(option.id)
		this.props.fieldValue.input.onChange(option.value)
		if (this.props.onClick) {
			this.props.onClick(option)
		}
		this.setState({ searchSuggestions: false })
	}

	handleClickLastRow() {
		if (this.props.lastRowAction) {
			this.props.lastRowAction()
		}
		this.setState({ searchSuggestions: false })
	}

	handleClickOutside() {
		this.setState({ isOpened: false })
	}

	doFocus() {
		if (this.state.locked) {
			return
		}
		this.setState({ isOpened: true })
	}

	doBlur() {
		if (this.state.locked) {
			return
		}
		this.setState({ isOpened: false })
	}

	listElements(options) {
		if (!(Object.keys(options).length === 0 && options.constructor === Object)) {
			return options.map(option => (
				<li
					key={option.id}
					styleName='list-item'
					onClick={() => this.handleClick(option)}>
					<label styleName='list-item-label'>
						{option.value}
					</label>
				</li>
			))
		} else {
			return null
		}
	}

	render() {
		return (
			<ClickOutside
				clickOutsideHandler={this.handleClickOutside}>
				<div styleName={
					classNames({
						wrapper: true,
						'wrapper-index': this.state.isOpened,
					})}
				>
					<TextInput
						{...this.props.fieldValue.input}
						type='text'
						tabIndex={this.props.tabIndex}
						disabled={this.props.disabled}
						active={this.state.isOpened}
						onChange={this.searchSuggestions}
						placeholder={this.props.placeholder}
						onFocus={this.doFocus}
						onBlur={this.doBlur}
						autoComplete='off'
						autoFocus={this.props.autoFocus}
					/>
					<CSSTransition
						in={
							!!(this.state.isOpened &&
							(this.props.fieldValue.input.value || !this.props.showBottomRow) &&
							(this.props.fieldValue.meta.dirty || this.state.searchSuggestions) &&
							(this.props.options.length || this.props.showBottomRow))
						}
						classNames={{
							enter: styles.enter,
							enterActive: styles['enter-active'],
							exit: styles.exit,
							exitActive: styles['exit-active'],
						}}
						timeout={300}
						unmountOnExit
					>
						<div styleName='suggestions'>
							<ul styleName='list'>
								{this.listElements(this.props.options)}
							</ul>
							{ this.props.showBottomRow &&
								<p styleName='new-item' onClick={this.handleClickLastRow}>
									{localize('suggestion_list_new_item')} <TextLink>{this.props.lastRowActionCopy}</TextLink>
								</p>
							}
						</div>
					</CSSTransition>
				</div>
			</ClickOutside>
		)
	}
}

SuggestionList.defaultProps = {
	showBottomRow: true,
	autoFocus: false,
	additionalOnChange: () => {},
	lastRowActionCopy: localize('suggestion_list_new_item_link'),
}

export default CSSModules(SuggestionList, styles, {allowMultiple: true})
